<!-- 志扬学苑 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_innovate.jpg"
      class="banner"
    />
    <div :class="{ wrap: true, bg2: activeTab == 1, bg3: activeTab == 2 }">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <div class="thirdNavs">
          <div
            :class="{ nav: true, active: activeTab == 0 }"
            @click="changeTab(0)"
          >
            志扬人才培育
          </div>
          <div
            :class="{ nav: true, active: activeTab == 1 }"
            @click="changeTab(1)"
          >
            专业技术研究
          </div>
          <div
            :class="{ nav: true, active: activeTab == 2 }"
            @click="changeTab(2)"
          >
            赋能行业人才
          </div>
        </div>
      </div>
      <div class="tab" v-show="activeTab == 0">
        <div class="w1200">
          <sub-title
            title="志扬人才培育"
            en="ZHI YANG TALENT CULTIVATION"
          ></sub-title>
        </div>
        <div class="talent">
          <div class="left">
            <div class="in">
              <div class="title">（一）人才培育体系</div>
              <div class="info">
                <p>
                  对进入志扬不同阶段、不同类型的人才，通过人才培育体系，
                  根据其个人特质及发展取向，有针对性的进行个性化人才孵化，力
                  争做到激发潜力，人尽其才，为公司的发展做好各类型的人才储备。
                </p>
                <p class="b">1、雏鹰计划</p>
                <p>
                  行业新秀人才，实战专业导师手把手专业对口带教，理论与实践相结合，根据其个人特质及发展方向，建立职业生涯规划，指明发展方向，插上腾飞的翅膀，助力人才早日鲲鹏展翅。
                </p>
                <p class="b">2、飞鹰计划</p>
                <p>
                  行业初涉人才，根据人才既有专业实践基础及认知，以行业发展趋势及市场需求为导向，建立对行业新的认知和自我重塑，升级个人职业发展规划和发展路径，助力人才早日展翅高飞。
                </p>
                <p class="b">3、雄鹰计划</p>
                <p>
                  行业熟练人才，通过人才评测体系，发现和发掘优秀专业人才，取长补短，重塑行业信念，树立行业标杆，并以此为目标，打造行业各类型专家级人才队伍，助力人才像雄鹰一样翱翔于天际。
                </p>
              </div>
            </div>
          </div>
          <img
            src="http://api.zyzxgc.cn/file/static/talent_img.png"
            alt=""
            class="talent-img"
          />
        </div>
      </div>
      <div class="tab" v-show="activeTab == 1">
        <div class="w1200">
          <sub-title
            title="专业技术研究"
            en="SPECIALIZED TECHNICAL RESEARCH"
          ></sub-title>
        </div>
        <div class="out">
          <div class="box2 w1200">
            <img
              src="http://api.zyzxgc.cn/file/static/research_img.png"
              alt=""
              class="left"
            />
            <div class="right">
              <div class="title">（二）专业技术研究</div>
              <div class="line"></div>
              <div class="desc">
                以赋能国家工程建设为使命，助力高质量发展为引领，助力实现项目建设目标为导向，以超越客户需求为出发点，以持续解决行业和客户痛点为核心，坚持长期主义，拥抱市场，深耕行业，精研专业技术，致力于打造以“技术、造价、合约、采购、法务、财税”为竞争核心的多维度融合的赋能体系，致力于打造以投资咨询、招投标、勘察、设计、施工、监理、造价、项目管理等多专业融合的全过程工程咨询及工程建设管理的产品体系。
              </div>
            </div>
          </div>
          <div class="cross"></div>
        </div>
      </div>
      <div class="tab" v-show="activeTab == 2">
        <div class="w1200">
          <sub-title
            title="赋能行业人才"
            en="ENPOWER INDUSTRY TALENTS"
          ></sub-title>
        </div>
        <div class="out">
          <div class="cross3"></div>
          <div class="box3 w1200">
            <div class="left">
              <div class="title">（三）赋能行业人才</div>
              <div class="line"></div>
              <div class="desc">
                工程建设领域经过几十年的发展，行业从业人才数量巨大，但人才质量水平参差不齐，复合型的高水平工程建设人才一度稀缺，伴随着国家高质量发展战略的实施，对复合型高质量工程建设人才的需求更是与日俱增。志扬愿为行业人才建设添砖加瓦，以志扬人才培育体系及专业技术研究成果为基础，致力于打造志扬行业人才赋能体系，为行业培育复合型的高质量工程建设人才。
              </div>
            </div>
            <img
              src="http://api.zyzxgc.cn/file/static/industry_img.png"
              alt=""
              class="right"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      activeTab: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
    if (this.$route.query.tab !== undefined) {
      this.activeTab = this.$route.query.tab;
    }
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    changeTab(idx) {
      this.$router.replace("/innovate/academe?tab=" + idx);
      this.activeTab = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .bg2 {
    background-image: url("http://api.zyzxgc.cn/file/static/research_bg.png");
  }
  .bg3 {
    background-image: url("http://api.zyzxgc.cn/file/static/industry_bg.png");
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;

    .thirdNavs {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;

      .nav {
        font-size: 20px;
        color: #9a9a9a;
        line-height: 26px;
        cursor: pointer;

        &:hover {
          color: $theme;
          font-weight: bold;
        }

        & + .nav {
          margin-left: 35px;
        }
      }
      .active {
        color: $theme;
        font-weight: bold;
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 37px;
          height: 3px;
          background-color: $theme;
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .talent {
    margin-top: 25px;
    display: flex;
    align-items: center;

    .left {
      flex-grow: 1;
      height: 600px;
      background-image: url("http://api.zyzxgc.cn/file/static/talent_box.png");
      background-size: 100% 100%;
      position: relative;

      .in {
        position: absolute;
        top: 50%;
        right: 10%;
        transform: translateY(-50%);
      }
      .title {
        width: 500px;
        font-size: 22px;
        color: #5e5d5d;
        margin-bottom: 20px;
      }
      .info {
        width: 500px;
        font-size: 15px;
        color: #5e5d5d;
        text-indent: 2em;
        line-height: 30px;

        .b {
          font-weight: bold;
          text-indent: 0;
        }
      }
    }
    .talent-img {
      width: 50vw;
      margin-left: -100px;
    }
  }

  .out {
    margin: 50px 0 120px;
    position: relative;

    .cross {
      width: 100%;
      height: 400px;
      background-color: $theme;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .cross3 {
      width: 100%;
      height: 63px;
      background-color: $theme;
      position: absolute;
      left: 0;
      bottom: 15%;
    }
  }
  .box2 {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;

    .left {
      flex: 1;
    }
    .right {
      flex: 1;
      padding: 44px 0 44px 25px;
      color: #fff;

      .title {
        font-size: 24px;
      }
      .line {
        width: 107px;
        height: 4px;
        background-color: #fff;
        margin: 30px 0;
      }
      .desc {
        text-indent: 2em;
        font-size: 15px;
        line-height: 30px;
      }
    }
  }
  .box3 {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;

    .right {
      width: 50vw;
    }
    .left {
      flex-shrink: 0;
      width: 460px;
      margin-right: 56px;
      color: #5e5d5d;

      .title {
        font-size: 24px;
      }
      .line {
        width: 107px;
        height: 2px;
        background-color: #5e5d5d;
        margin: 30px 0;
      }
      .desc {
        text-indent: 2em;
        font-size: 15px;
        line-height: 30px;
      }
    }
  }
}

@media (max-width: 1500px) {
  .frame .out .cross3 {
    bottom: 6%;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .thirdNavs {
        padding: 0 10px;
        margin-bottom: 30px;

        .nav {
          font-size: 16px;

          & + .nav {
            margin-left: 10px;
          }
        }
      }
    }
    .w1200 {
      padding: 0 10px;
      box-sizing: border-box;
    }
    .talent {
      padding: 0 10px;
      box-sizing: border-box;
      display: block;

      .left {
        height: auto;

        .in {
          position: static;
          transform: none;
          padding: 20px 10px 20px 80px;

          .title,
          .info {
            width: 100%;
          }
          .title {
            font-size: 16px;
          }
          .info {
            font-size: 14px;
          }
        }
      }
      .talent-img {
        width: 100%;
        margin-left: 0;
      }
    }
    .out {
      margin: 20px 0;

      .cross {
        width: 100%;
        height: 100%;
      }
    }
    .box2 {
      padding: 0 10px;
      box-sizing: border-box;
      flex-direction: column-reverse;

      .left {
        width: 100%;
      }
      .right {
        padding: 10px 0;

        .title {
          font-size: 18px;
        }
        .line {
          height: 2px;
          margin: 10px 0;
        }
        .desc {
          font-size: 14px;
        }
      }
    }
    .box3 {
      display: block;

      .left {
        width: 100%;

        .title {
          font-size: 18px;
        }
        .line {
          margin: 20px 0;
        }
        .desc {
          font-size: 14px;
        }
      }
      .right {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}
</style>
